const size = {
  largeScreen: "(min-width: 1481px)",
  wideScreen: "(min-width: 1280px) and (max-width: 1480px)",
  maxWideScreen: "(max-width: 1480px)",
  mobileScreen: "(max-width: 1279px)",
  mobilePortrait: "(max-width: 480px)",
  portraitDevice: "(max-width: 767px)",
  desktopScreen: "(min-width: 1280px)",
  tabletScreenLandscape:
    "(min-width: 768px) and (max-width: 1279px) and (orientation: landscape)",
  tableScreenPortrait: "(min-width: 768px) and (max-width: 1024px)"
};
export const device = {
  largeScreen: `${size.largeScreen}`,
  wideScreen: `${size.wideScreen}`,
  maxWideScreen: `${size.maxWideScreen}`,
  mobileScreen: `${size.mobileScreen}`,
  mobilePortrait: `${size.mobilePortrait}`,
  portraitDevice: `${size.portraitDevice}`,
  desktopScreen: `${size.desktopScreen}`,
  tabletScreenLandscape: `${size.tabletScreenLandscape}`,
  tableScreenPortrait: `${size.tableScreenPortrait}`
};
